function convertDate(date) {
    let newDate = date.split("/");
    return new Date(`${newDate[2]}-${newDate[1]}-${newDate[0]}`)
}

// usado para setar 0 nos campos não selecionado quando o atributo nao for nenhum 
function IsNone(obj, atribute) {
    if (obj[atribute] === 0) {
        for (let chave in obj) {
            if (chave !== atribute) {
                obj[chave] = 0;
            }
            else {
                obj[chave] = 1;
            }

        }
    }
    else {
        obj[atribute] = 0
    }
    return obj;

}

function resetValues(obj) {
    for (let chave in obj) {
        obj[chave] = 0;
    }
    return obj;

}

function InsertNullPropeties(objeto1, objeto2) {
    for (let nivel1 in objeto2) {
        if (objeto2[nivel1] === null) {
            objeto2[nivel1] = objeto1[nivel1];
        }
        else {
            for (let nivel2 in objeto2[nivel1]) {
                if (objeto2[nivel1][nivel2] === null) {
                    objeto2[nivel1][nivel2] = objeto1[nivel1][nivel2];
                }
                else {
                    for (let nivel3 in objeto2[nivel1][nivel2]) {
                        if (objeto2[nivel1][nivel2][nivel3] === null) {
                            objeto2[nivel1][nivel2][nivel3] = objeto1[nivel1][nivel2][nivel3];
                        }
                    }
                }
            }
        }
    }

    return objeto2;
}

function fillNulls(target, source) {
    if (!source || typeof source !== 'object') return target;

    Object.keys(target).forEach((key) => {
        const tVal = target[key];
        const sVal = source[key];

        if (tVal === null && sVal !== undefined) {
            // só copia se o destino é null E o source realmente tem esse campo
            target[key] = sVal;
        } else if (
            tVal !== null &&
            typeof tVal === 'object' &&
            sVal &&
            typeof sVal === 'object'
        ) {
            // desce recursivamente em objetos/arrays
            fillNulls(tVal, sVal);
        }
        // se tVal já tem valor, não faz nada
    });

    return target;
}

//usado para as validações de checkbox
function validateObject(obj, teste) {
    console.log(obj, teste)
    for (const key in obj) {
        if (Number(obj[key]) === 1 || Number(obj[key]) === 2 || Number(obj[key]) === 3) {
            return true; // Se encontrar um atributo com valor 1, retorna true
        }
    }
    return false; // Se nenhum atributo tiver valor 1, retorna false
}


function validateObject2(obj, teste) {
    for (const key in obj) {
        if (Number(obj[key]) !== 0) {
            return true; // Se encontrar um atributo com valor 1, retorna true
        }
    }
    return false; // Se nenhum atributo tiver valor 1, retorna false
}

function IsContains(number, array) {
    for (const key in array) {
        if (Number(array[key]) === number) {
            return true; // Se encontrar um atributo com valor 1, retorna true
        }
    }
    return false; // Se nenhum atributo tiver valor 1, retorna false
}

const numerateView = () => {
    const numeros = [];
    for (let i = 5; i <= 50; i += 5) {
        numeros.push(i);
    }
    return numeros
}

function hasValue(array) {
    console.log(array)
    if (!Array.isArray(array)) return false;

    return array.some(item =>
        item &&
        typeof item === 'object' &&
        Object.values(item).some(val =>
            val !== null &&
            val !== undefined &&
            val !== ''
        )
    );
}


export { convertDate, IsNone, InsertNullPropeties, validateObject, validateObject2, numerateView, resetValues, IsContains, hasValue, fillNulls }